import React, { useEffect, useState } from "react";
import { StudentPersonalDetailsType } from "../types";
import axios from "../../../axios";
import TheSpinner from "../../TheSpinner";
import { List } from "antd";
import { dateDisplayable } from "../../table-utils";
import { TABLE_LIMIT } from "../../constants";

interface Comment {
  id: number;
  comment: string;
  rating: number;
  admin_name: string;
  created_at: string;
}

type PersonalDetailsCommentProps = {
  studentDetails: StudentPersonalDetailsType;
};

function Comments(props: PersonalDetailsCommentProps) {
	const { studentDetails } = props;
  const [page, setPage] = useState(1);
  const [comments, setComments] = useState<Comment[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
	const [subscriptionHistoryMeta, setSubscriptionHistoryMeta] = useState<any>({});

  const fetchComments = async () => {
    try {
      const response = await axios.get(
        "/v1/cre/student/deal/student-comment/all",
        {
          params: {
            student_id: studentDetails.userId,
						page,
						limit: TABLE_LIMIT,
          },
        }
      );
      console.log("Actual response", response);

      setComments(response?.data?.data?.result);
			setSubscriptionHistoryMeta(response?.data?.data?.meta);
    } catch (err) {
      console.log("Error fetching comments", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchComments();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  if (loading) {
    return <TheSpinner />;
  }

	return (
    <List
      itemLayout="vertical"
      size="small"
      pagination={{
        total: subscriptionHistoryMeta?.total ?? 0,
        pageSize: TABLE_LIMIT,
        onChange: (page, _pageSize) => setPage(page),
        showSizeChanger: false,
        current: page,
      }}
      dataSource={comments}
      renderItem={(item) => (
        <List.Item key={item.id}>
          <List.Item.Meta
            description={item?.comment}
            title={item?.admin_name}
          />
          <p className="tail-text-xs tail-text-gray-500">
            {dateDisplayable(item.created_at)}
          </p>
        </List.Item>
      )}
    />
  );
}

export default Comments;
